export const clamp = (value: number, min = 0, max = 1): number => {
    return Math.min(max, Math.max(min, value))
}

export const lerp = (from: number, to: number, t: number): number => {
    return from + (to - from) * t
}

export const invLerp = (from: number, to: number, value: number): number => {
    if (to === from) return value >= to ? 1 : 0

    return (value - from) / (to - from)
}

export const range = (from: number, to: number, value: number): number => {
    return clamp(invLerp(from, to, value))
}

export const smoothstep = (from: number, to: number, value: number): number => {
    const t = range(from, to, value)

    return t * t * (3 - 2 * t)
}

export const smootherstep = (from: number, to: number, value: number): number => {
    const t = range(from, to, value)

    return t * t * t * (t * (t * 6 - 15) + 10)
}

export const damp = (current: number, target: number, lambda: number, dt: number): number => {
    return lerp(current, target, 1 - Math.exp(-lambda * dt))
}

export const easeOutCubic = (t: number): number => 1 - Math.pow(1 - t, 3)

export const easeInOutCubic = (t: number): number => {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
}

export const easeInOutSine = (t: number): number => -(Math.cos(Math.PI * t) - 1) / 2

export const easeOutExpo = (t: number): number => (t >= 1 ? 1 : 1 - Math.pow(2, -10 * t))

export const easeInOutQuart = (t: number): number => {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2
}

/**
 * Turns a 0..1 progress into a stepped value with soft transitions.
 * Each window [start, end] adds one full step, eased with smootherstep.
 */
export const stepped = (progress: number, windows: Array<[number, number]>): number => {
    let value = 0

    for (const [start, end] of windows) {
        value += smootherstep(start, end, progress)
    }

    return value
}

export const mixHex = (from: string, to: string, t: number): string => {
    const a = parseInt(from.slice(1), 16)
    const b = parseInt(to.slice(1), 16)
    const k = clamp(t)

    const r = Math.round(lerp((a >> 16) & 255, (b >> 16) & 255, k))
    const g = Math.round(lerp((a >> 8) & 255, (b >> 8) & 255, k))
    const bl = Math.round(lerp(a & 255, b & 255, k))

    return `rgb(${r}, ${g}, ${bl})`
}
